import dynamic from 'next/dynamic';
import A from './components/A';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function PowerstreamCooperation() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`powerstream-cooperation ${css['powerstream-cooperation']}`}>
            <A />
            <IndexDynamic />
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
